import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";
import { LoadingService } from "../../../core/loader/loading.service";
import { NotificationService } from "../notification/notification.service";
import { DataType } from "./demo-data.type";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-demo-modal",
  templateUrl: "./demo-modal.component.html",
  styleUrls: ["./demo-modal.component.css"],
})
export class DemoDataModalComponent implements OnInit {
  currentValue = "";
  loading$ = this.loader.loading$;
  operation = "create";
  basePath = `${environment.serverUrl}/demo-data`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    public dialogRef: MatDialogRef<DemoDataModalComponent>,
    private http: HttpClient,
    private loader: LoadingService,
    private notificationService: NotificationService,
  ) {}

  @HostListener("window:keyup.esc") onKeyUp(): void {
    this.dialogRef.close(false);
  }

  ngOnInit(): void {}

  create(): void {
    this.http
      .post(this.basePath, { companyId: this.data.company?.id, partnerId: this.data.partner?.id })
      .subscribe(
        () => {
          this.notificationService.success("Demo data is being created. You will receive an email soon.");
        },
        (error) => {
          this.notificationService.error(error);
        },
      )
      .add(() => {
        this.dialogRef.close(true);
        this.loader.hide();
      });
  }

  clearField(): void {
    this.currentValue = "";
  }
}
